import { render, staticRenderFns } from "./ParciaisValorizacao.vue?vue&type=template&id=5ab3d109&scoped=true"
import script from "./ParciaisValorizacao.vue?vue&type=script&lang=js"
export * from "./ParciaisValorizacao.vue?vue&type=script&lang=js"
import style0 from "./ParciaisValorizacao.vue?vue&type=style&index=0&id=5ab3d109&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab3d109",
  null
  
)

export default component.exports